const JOB_TYPES = {
  ACTIONS: 0,
  ABSENCES: 1
};

export default JOB_TYPES;